import axios from 'axios';
import { getApiBase } from './apiBase';

const API_URL = getApiBase() + '/api';

// Kısa süre içinde aynı endpoint'i birden fazla component çağırırsa (mount loop / StrictMode / polling reset),
// ağ tarafında spam oluşmasın diye basit global cache + in-flight de-dup uygular.
//
// TTL: mevcut client polling aralığı (30sn) ile aynı ölçeğe çekildi.
const DEFAULT_TTL_MS = 30_000;

const inflight = new Map(); // key -> Promise
const cache = new Map(); // key -> { ts, data }

function makeKey(path, params) {
  const p = params && typeof params === 'object' ? JSON.stringify(params) : '';
  return `${path}?${p}`;
}

async function cachedGet(path, params, ttlMs = DEFAULT_TTL_MS) {
  const key = makeKey(path, params);
  const now = Date.now();
  const hit = cache.get(key);
  if (hit && now - hit.ts < ttlMs) return hit.data;
  if (inflight.has(key)) return inflight.get(key);

  const p = axios
    .get(`${API_URL}${path}`, { params })
    .then((res) => {
      const data = res?.data;
      cache.set(key, { ts: Date.now(), data });
      return data;
    })
    .catch((err) => {
      // Hata cache'lenmesin; bir sonraki request denesin.
      throw err;
    })
    .finally(() => {
      inflight.delete(key);
    });

  inflight.set(key, p);
  return p;
}

export function getActivityFeedUiConfigCached(ttlMs = DEFAULT_TTL_MS) {
  return cachedGet('/activity-feed/ui-config', undefined, ttlMs);
}

export function getActivityFeedHighlightsCached(limit, ttlMs = DEFAULT_TTL_MS) {
  return cachedGet('/activity-feed/highlights', { limit }, ttlMs);
}

